
import { UPLOADMULTIPLEFILES_TYPES } from '../actions/uploadMultipleFiles'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(UPLOADMULTIPLEFILES_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer